let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page765_game3/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page765_game3/audio/65_T-shirt.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 230,
        x: 465,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/63_pat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 330,
        x: 740,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 90,
        x: 950,
      },
      unit: 'px',
    },

    {
      src: 'games/page765_game3/audio/57_legs.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 270,
        x: 1200,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/66_dress.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 260,
        x: 1640,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/70_jeans.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 420,
        x: 420,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 540,
        x: 1630,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/59_head.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 375,
        x: 960,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/60_tummy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 535,
        x: 760,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/62_shake.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 625,
        x: 1190,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/67_jumper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 390,
        x: 1440,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/58_hands.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 620,
        x: 1416,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/69_shoes.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 650,
        x: 965,
      },
      unit: 'px',
    },
    {
      src: 'games/page765_game3/audio/61_stretch.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page765_game3/img/audioOn.png', iconOff: 'games/page765_game3/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 680,
        x: 525,
      },
      unit: 'px',
    },
  ],
};

export default elements;
